export const ArchidriveFilterComponent = {
    template: require('./archidrive-filter.html'),
    controller: class ArchidriveFilterComponent {

        private filter: any;

        private resolve: any;
        private close: any;
        private dismiss: any;

        $onInit(): void {
            this.filter = this.resolve.filter;
        }

        clearFilter() {
            this.filter.fileName = '';
            this.filter.dataFrom = '';
            this.filter.dataTo = '';
        }

        updateDateField(field: string, value: Date) {
            this.filter[field] = value;
        }

        search() {
            this.close({ $value: this.filter });
        }

        cancel() {
            this.dismiss();
        }
    },
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/archidrive/archidrive-filter/archidrive-filter.ts